import { useMemo } from 'react'

import { LevelPlayFinish } from '@/shared/level-play'
import { Button } from '@/shared/ui/Button'

import { useQuizContext } from '../context'

/**
 * Conclusão do quiz — wrapper de domínio sobre `LevelPlayFinish`.
 *
 * O percentual vem de `progress.finished_percent` (0 a 100, convertido aqui), e
 * o acerto de cada pergunta sai de `progress.answeres`, indexado por
 * `quiz_question_id`. `answeres` é o nome do campo na API — não é erro de
 * digitação nosso.
 */
export const DigitalProductQuizQuizFinish = () => {
  const {
    rewards,
    questions,
    allowWrongAnswers,
    progress,
    config: { basePath }
  } = useQuizContext()

  const items = useMemo(() => {
    const answers = progress?.answeres ?? []

    return (questions ?? []).map(question => ({
      id: question.uid,
      name: question.name,
      correct: !!answers.find(answer => answer.quiz_question_id == question.id)
        ?.right_answer
    }))
  }, [questions, progress?.answeres])

  return (
    <LevelPlayFinish
      correctPercent={(progress?.finished_percent ?? 0) / 100}
      rewards={rewards}
      showBreakdown={allowWrongAnswers}
      items={items}
      actions={
        <Button href={basePath} variant="ghost" className="grow">
          Voltar para os quizzes
        </Button>
      }
    />
  )
}
